import { isEqual } from 'lodash';

export const isEmptyString = (value: string): boolean => {
  if (!value) {
    return true;
  }
  return isEqual(value, '');
};